<template>
    <div id="nav">
        <router-link to="/works" class="nav-items" id="left-menu-item" exact>
            {{ leftTab }}
        </router-link>
        <router-link to="/" class="nav-items" id="center-menu-item" exact>
            <img width="20" :src="require('../assets/logo.svg')"/>
        </router-link>
        <router-link to="/about" class="nav-items" id="right-menu-item" exact>
            {{ rightTab }}
        </router-link>
    </div>
</template>

<script>
	export default {
		name: "Toolbar",
		data() {
			return {
				brand: "@",
				leftTab: "Works",
				rightTab: "About"
			};
		}
	};
</script>

<style lang="scss" src="../styles/toolbar.scss" scoped/>
